import _ from '../../../util/underscore-wrapper';
import 'qtip';
import BaseView from '../../BaseView';
import hbs from 'handlebars-inline-precompile';
/**
 * @class InputLabel
 * @extends {Okta.View}
 * @private
 * The input's label.
 */
export default BaseView.extend({
  className: 'okta-form-label o-form-label',

  attributes: {
    'data-se': 'o-form-label'
  },

  /**
   * @constructor
   * @param  {Object} options options hash
   * @param  {String} [options.type] Input type
   * @param  {String|Function} [options.label] Label text
   * @param  {String|Function} [options.sublabel] Sub label text
   * @param  {String|Function} [options.tooltip] Tooltip text
   * @param  {String|Function} [options.inputId] Id of the inputs
   * @param  {String|Function} [options.id] Id of the inputs
   */
  constructor: function (options) {
    /* eslint max-statements: [2, 16] complexity: [2, 7]*/
    _.defaults(options, { inputId: options.id });
    delete options.id;

    BaseView.apply(this, arguments);
  },

  // standardLabel: space added in the end of the label to avoid selecting label text with double click in read mode
  template: hbs`
    {{#if _isLabelView }}
      <label for="{{inputId}}"></label>
    {{/if}}
    {{#if _isRadioOrCheckbox }}
      {{label}}
    {{/if}}
    {{#if _standardLabel }}
      <label for="{{inputId}}">{{label}}&nbsp;</label>
    {{/if}}
    {{#if sublabel }}
      <span class="o-form-explain">{{sublabel}}</span>
    {{/if}}
    {{#if tooltip }}
      <span class="o-form-tooltip icon-16 icon-only form-help-16" title="{{tooltip.text}}"></span>
    {{/if}}
  `,

  getTemplateData: function () {
    const options = { label: '' };

    _.each(
      ['inputId', 'label', 'sublabel', 'tooltip'],
      function (option) {
        options[option] = _.resultCtx(this.options, option, this);
      },
      this
    );

    if (this._isLabelView(options.label)) {
      options._isLabelView = true;
    } else if (_.contains(['radio', 'checkbox'], this.options.type) || !options.label) {
      options._isRadioOrCheckbox = true;
    } else {
      options._standardLabel = true;
    }
    if (options.tooltip) {
      if (_.isString(options.tooltip)) {
        options.tooltip = {
          text: options.tooltip
        };
      }
    }
    return options;
  },

  _isLabelView: function (label) {
    return !_.isUndefined(label) && label instanceof BaseView;
  },

  postRender: function () {
    const options = this.getTemplateData();

    if (this._isLabelView(options.label)) {
      this.removeChildren();
      this.add(options.label, 'label');
    }

    if (options.tooltip) {
      this.$('.o-form-tooltip').qtip(
        _.extend(
          {
            style: { classes: 'qtip-custom qtip-shadow' },
            position: {
              my: (window.okta && window.okta.theme === 'dstheme') ? 'bottom center' : 'bottom left',
              at: 'top center'
            },
            hide: { fixed: true },
            show: { delay: 0 }
          },
          options.tooltip.options
        )
      );
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/views/forms/helpers/InputLabel.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/views/forms/helpers/InputLabel.js